module.exports = new __parcel__URL__("sqlserver.902844c6.png").toString();